import { Gruppe, GruppeLight, GruppeMedlemskap, IdentitetLight, PaginatedResult } from '../../../models';
import RequestService, { getNextPageURL } from '../requestService';
import { client } from '../../client';
import { EnkelMedlem, MedlemskapFetchArgs, MedlemskapIdListe } from '../../../features/medlemmer/MedlemskapHelper';
import { tEntityId } from '../../../models/entity';
export default class GruppeService extends RequestService<Gruppe, 'gruppe'> {
    constructor() {
        super('gruppe');
    }
    fetchGruppeMedlemskap = async ({ gruppeId, query, ...param }: MedlemskapFetchArgs) =>
        client.get<PaginatedResult<GruppeMedlemskap>>(getNextPageURL({ endpoint: `${this.serviceName}/${encodeURIComponent(gruppeId)}/medlemskap`, query, param }));
    fetchMedlemskapIdentitet = async ({ gruppeId, query, ...param }: MedlemskapFetchArgs) =>
        client.get<PaginatedResult<IdentitetLight>>(getNextPageURL({ endpoint: `${this.serviceName}/${encodeURIComponent(gruppeId)}/medlemskap/identitet`, query, param }));
    postGruppeMedlemskap = async (tgId: tEntityId, medlemmer: EnkelMedlem[]) => client.post<MedlemskapIdListe>(`${this.serviceName}/${encodeURIComponent(tgId)}/medlemskap`, medlemmer);
    deleteGruppeMedlemskap = async (itemId: tEntityId, sletedeListe: EnkelMedlem[]) => client.put<MedlemskapIdListe[]>(`${this.serviceName}/${encodeURIComponent(itemId)}/medlemskap/slet`, sletedeListe);
    hentGruppeListe =
        async (searchString: string) =>
            client.get<GruppeLight[]>
                (`${this.serviceName}/hentGruppeListe?q=${encodeURIComponent(searchString)}`);
}